export default __webpack_public_path__ + "static/media/partner_program.71e30f5a.png";